import { render, staticRenderFns } from "./StatsPhoenixPartnersDetails.vue?vue&type=template&id=2f78af5b&"
import script from "./StatsPhoenixPartnersDetails.vue?vue&type=script&lang=js&"
export * from "./StatsPhoenixPartnersDetails.vue?vue&type=script&lang=js&"
import style0 from "./StatsPhoenixPartnersDetails.vue?vue&type=style&index=0&id=2f78af5b&prod&lang=scss&"
import style1 from "./StatsPhoenixPartnersDetails.vue?vue&type=style&index=1&id=2f78af5b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports